var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-4"},[_vm._m(0),_c('h1',{staticClass:"h5 mb-1 text-center"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('p',{staticClass:"lead text-muted text-center"},[_vm._v("Last "+_vm._s(_vm.subtitle))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center mb-3"},[_c('img',{attrs:{"src":require("@/assets/etherbit.svg"),"height":"25"}})])
}]

export { render, staticRenderFns }